/**
 * Created by Karan variya on 22/12/2018.
 */
import { Injectable, Output, EventEmitter } from '@angular/core';
import 'rxjs/Rx';
import 'rxjs/add/operator/toPromise';
import 'rxjs/add/operator/map';
import 'rxjs/add/operator/catch';
import { Admin } from './../../modal/admin'
import { HttpManagerService } from '../../api/httpmanager.service';
@Injectable()
export class LoginService {
    @Output() getLoggedInRole: EventEmitter<any> = new EventEmitter();
    public authToken: string;
    public authRole: string;
    public authJoinCode: string;
    constructor(
        private httpmanagerService: HttpManagerService
    ) {
    }
    public storeUserData(token, role, joincode) {
        localStorage.setItem('id_token', token);
        localStorage.setItem('type', role);
        localStorage.setItem('joincode', joincode);
        this.authToken = token;
        this.authRole = role;
        this.authJoinCode = joincode;
    }
    loginUser(user): Promise<Admin> {
        return this.httpmanagerService.HttpPost('slogin', JSON.stringify(user), "").then(data => {
            if (data.status == true) {
                this.getLoggedInRole.emit(data.role);
            } else {
                this.getLoggedInRole.emit('Sign In');
            }
            return data;
        })
    }
    public loadToken() {
        const token = localStorage.getItem('id_token');
        const type = localStorage.getItem('type');
        const joincode = localStorage.getItem('joincode');
        this.authToken = token;
        this.authRole = type;
        this.authJoinCode = joincode;
        this.getLoggedInRole.emit(this.authRole);
    }
    public returnToken(): string {
        if (this.authToken != null) {
            return this.authToken.toString();
        }
        return "";
    }
    public logout() {
        this.getLoggedInRole.emit('Sign In');
        localStorage.removeItem('id_token');
        localStorage.removeItem('type');
        localStorage.removeItem('joincode');
        localStorage.clear();
    }
}


// WEBPACK FOOTER //
// F:/SVNNew/Web/Phoenix HealthCare/HealthCare_UI/src/api/login/login.service.ts